<!--
  @description
  A small registry component that dynamically renders icon components
  by name. Pass the icon name via the `name` prop, to look up and render
  the corresponding SFC (single-file component).

  Example usage:
  <IconRegistry name="HelpCenterIcon" iconClass="my-custom-class" />

  Props:
  - name: String (required) — The icon’s internal name (e.g. "HelpCenterIcon")
  - iconClass: String (optional) — An extra class applied to the icon component.
-->

<template>
  <component :is="fetchedIcons" v-bind="$attrs" :class="iconClass" />
</template>

<script>
import HelpCenterIcon from '../../icons/HelpCenterIcon.vue'
import TelephoneIcon from '../../icons/TelephoneIcon.vue'
import WhatsAppIcon from '../../icons/WhatsAppIcon.vue'
import EmailIcon from '../../icons/EmailIcon.vue'
import DeviceMessageIcon from "../../icons/DeviceMessageIcon.vue";
import AppleStoreIcon from "../../icons/AppleStoreIcon.vue";
import GooglePlaystoreIcon from "../../icons/GooglePlaystoreIcon.vue";
import CashiaAppLogo from "../../icons/CashiaAppLogo.vue";
import GiftIcon from "../../icons/GiftIcon.vue";

export default {
  name: 'IconRegistry',
  props: {
    name: {
      type: String,
      required: true
    },
    iconClass: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    fetchedIcons () {
      const icons = {
        HelpCenterIcon,
        TelephoneIcon,
        WhatsAppIcon,
        EmailIcon,
				DeviceMessageIcon,
        AppleStoreIcon,
        GooglePlaystoreIcon,
        CashiaAppLogo,
        GiftIcon
      }

      // Single-File Component - lookup icon
      const sfcIcon = icons[this.name]

      if (!sfcIcon) {
        console.warn(`[IconRegistry] Invalid icon name "${this.name}"`)
        return null
      }

      return sfcIcon
    }
  }
}
</script>
